<template>
  <div class="login">
    <form class="login__form">
      <h2 class="login_form__heading">Zaloguj się:</h2>

      <div class="login__form__inputs">
        <label for="login">email</label>
        <input type="email"
               id="login"
               class="text_form"
               autofocus
               v-model='loginForm.email'/>

        <label for="password">hasło</label>
        <input type="password"
               id="password"
               class="text_form"
               v-model="loginForm.password"
        @keyup.enter="signInOnEnter">

        <span class="login__form__inputs__wrong-data-message"
              :class="{'login__form__inputs__wrong-data-message--visible': isloginDataIncorrect}">
          Konto o danym adresie e-mail lub haśle nie istnieje.
        </span>

        <button type="button" class="button" @click="signIn">Zaloguj</button>
      </div>
    </form>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'Login',
  data () {
    return {
      loginForm: {
        email: '',
        password: ''
      },
      isloginDataIncorrect: false
    }
  },
  created () {
    this.$emit('makeScrolled', true)
  },
  methods: {
    signIn () {
      let email = this.loginForm.email,
          password = this.loginForm.password;

      firebase.auth().signInWithEmailAndPassword(email, password)
        .then(loginData => {
          let user = loginData.user;

          if (user) this.$router.replace('/adminPanel')
        })
        .catch (error => {
          this.isloginDataIncorrect = true
        });
    },
    signInOnEnter () {
      this.signIn()
    }
  }
}
</script>
